import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { GoodsCoreModel, IScreensLogging } from 'shared/src/api/types';

type LogClickGoodsParams = {
  item: GoodsCoreModel;
  logging: IScreensLogging;
};

export const useLogClickGoods = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ item, logging }: LogClickGoodsParams) => {
      logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: logging.analytics,
        ably_only_log: logging.ably_only_log,
      });

      if (isNotNil(item.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: item.ad });
      }
    },
    [logAnalyticsEvent],
  );
};
